<script setup lang="ts">
import { Video } from 'lucide-vue-next'

/** The product's mark: a camera on the AI gradient. */
withDefaults(defineProps<{ size?: 'sm' | 'md' }>(), { size: 'md' })
</script>

<template>
  <span
    class="inline-flex items-center justify-center rounded-2xl bg-ai text-white shadow-card"
    :class="size === 'sm' ? 'size-8 rounded-xl' : 'size-11'"
  >
    <Video :class="size === 'sm' ? 'size-4' : 'size-5'" :stroke-width="2" />
  </span>
</template>
